export default {
    CREATE_PERMISSION: () => '/permission/createPermission',
    GET_ALL_PERMISSION: () => '/permission/getAllPermission',
    DELETE_PERMISSION: (id) => `/permission/deletePermission/${id}`,
    UPDATE_PERMISSION: (id) => `/permission/updatePermission/${id}`,
    GET_PERMISSION_ID: (id) => `/permission/getPermissionBy/${id}`,
};
